import { useTheme } from 'styled-components'

import { Typography } from '../../Typography'

import {
  StyledContainer,
  StyledSubtitle,
  StyledTitle,
} from './ScreenTitle.Styled'
import type { ScreenTitleProps } from './ScreenTitle.Types'

export const ScreenTitle = ({
  align = 'left',
  subtitle,
  highlight,
  subtitleColorVariant = 'secondary-highlight-primary',
  title,
  titleSize = 'h2',
}: ScreenTitleProps) => {
  const theme = useTheme()

  return (
    <StyledContainer $align={align}>
      <StyledTitle
        $variant={
          titleSize === 'h1' ? 'Poppins/H1 - Medium' : 'Poppins/H2 - Medium'
        }
        as={titleSize === 'h1' ? 'h1' : 'h2'}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {highlight && (
        <Typography
          $color={theme.colors['N Content/Highlighted']}
          $variant="Poppins/T2 - Semibold"
          dangerouslySetInnerHTML={{ __html: highlight }}
        />
      )}
      {subtitle && (
        <StyledSubtitle
          $colorVariant={subtitleColorVariant}
          $variant="Poppins/T2"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </StyledContainer>
  )
}
